import dynamic from 'next/dynamic'
import PageTitle from 'components/page-title/page-title'
import Meta from 'components/meta/meta'
import { getData } from 'utils/api'
import Faqs from 'components/faqs/faqs'
import PageHead from 'components/page-head/page-head'
import PageFoot from 'components/page-foot/page-foot'

const Products = dynamic(() => import('components/hits/products'))

export default function Page(category) {
    let description = `Prekės pagal raktažodį - ${category.name}.`
    if (category.meta_description) {
        description = category.meta_description
    } else if (category.description) {
        description = category.description
    }

    let bottomDescription = category.long_description
    if (!bottomDescription && category.filter && category.description) {
        bottomDescription = category.description
    }

    const title = category.name ? category.name[0].toUpperCase() + category.name.substring(1) : ''

    return (
        <>
            <Meta title={title} description={description} />
            {category.description ? (
                <PageHead title={title} description={category.description} />
            ) : (
                <PageTitle>{title}</PageTitle>
            )}
            <Products filter={`all_tags:"${category.name}"`} />
            {bottomDescription && <PageFoot>{bottomDescription}</PageFoot>}
            {!!category.faqs?.length && <Faqs items={category.faqs} />}
        </>
    )
}
// export default function Page(props) {
//     const name = props ? props.name : ''
//     const title = name ? name[0].toUpperCase() + name.substring(1) : ''
//     return (
//         <>
//             <Meta title={title} description={`Prekės pagal raktažodį - ${title}`} />
//             <PageTitle>{title}</PageTitle>
//             <Products filter={`all_tags:"${props.name}"`} />
//         </>
//     )
// }

export async function getStaticProps(context) {
    return getData(`tag/${context.params.slug}`)
}

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: true
    }
}
